import { Box, Typography } from "@mui/material";
import {
  Logo,
  Point1,
  Point2,
  Point3,
  Root,
  Text,
} from "./Authentication.styles";

const AuthenticationLoading: React.FC = () => {
  return (
    <Root>
      <Logo />
      <Text variant="h5">
        <img
          src="/assets/images/savio-filoblu-small.gif"
          alt="savio-filoblu-small.gif"
        ></img>
        <Box>
          User configuration
          <br />
          Please wait<Point1>.</Point1>
          <Point2>.</Point2>
          <Point3>.</Point3>
        </Box>
      </Text>
    </Root>
  );
};

export default AuthenticationLoading;
